import React from 'react'
import { useSelector } from 'react-redux'
import { Button, Grid, Row, Col } from 'rsuite'
import { selectPaymentCheckFailed } from '../../../../store/slices/payment/paymentSelectors'
import PaymentCheckFailed from './PaymentCheckFailed'
import usePlaceNavigate from '../../../../hooks/usePlaceNavigate'

const Success = ({ successComponent = () => null, showReturnToDashboardButton = true }) => {
    const placeNavigate = usePlaceNavigate();
    const paymentCheckFailed = useSelector(selectPaymentCheckFailed);

    return (
        <Grid>
            <Row className='mb-16 mt-16'>
                <Col xs={24}>
                    {
                        paymentCheckFailed && (
                            <PaymentCheckFailed />
                        )
                    }

                    {
                        !paymentCheckFailed && (
                            successComponent()
                        )
                    }
                </Col>
            </Row>
            {
                showReturnToDashboardButton && (
                    <Row>
                        <Col xs={24}>
                            <Button className='btn-primary' onClick={() => placeNavigate("/dashboard")}>Return to Dashboard</Button>
                        </Col>
                    </Row>
                )
            }
        </Grid>

    );
}

export default Success
